import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, Award, Heart, Globe, BookOpen, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function LeadershipPage() {
  return (
    <div className="@container/leadership max-w-[1800px] w-full mx-auto px-3 py-4 @[740px]/leadership:px-4 @[740px]/leadership:py-5 @[1100px]/leadership:px-6 @[1100px]/leadership:py-6 space-y-4 @[740px]/leadership:space-y-5 @[1100px]/leadership:space-y-6">
      <div className="space-y-3 @[740px]/leadership:space-y-4">
        <Badge variant="outline" className="mb-2">
          <Users className="mr-1 h-3 w-3" />
          Leadership
        </Badge>
        <h1 className="text-xl @[740px]/leadership:text-2xl @[1100px]/leadership:text-3xl font-bold">Dr. David Ogbueli</h1>
        <p className="text-muted-foreground text-lg">
          Minister of the Gospel, Social Reformer, and Transformational Leader
        </p>
      </div>

      <Card className="border-primary/20 bg-primary/5">
        <CardContent className="p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Award className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-semibold mb-2">Biography</h2>
              <p className="text-muted-foreground leading-relaxed">
                Dr. David Ogbueli is a Minister of the Gospel, a Social Reformer, and an iconic transformational leader. 
                He has great passion for Personal Transformation and National Transformation which has birthed various 
                initiatives and ministries causing a positive change among the youth, governments, corporate institutions, 
                the media and other stakeholders both in Africa and globally.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <Globe className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Global Impact</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-3">
              His media broadcast reaches seven continents with increasing transformational influence on many lives, 
              communities, cities & nations.
            </p>
            <p className="text-sm text-muted-foreground">
              He is a Management and Public Policy Consultant to private & public sector institutions and their leaders.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <BookOpen className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Publications</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              A widely read author with over one hundred and fifty books published. A widely sought after clergyman, 
              technocrat and teacher.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <Shield className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Recognition</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Honoured by the United Nations, state governments, government agencies, corporate agencies & organisations 
              for his youth development projects especially the annual National Youth Summit.
            </p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <Heart className="h-8 w-8 text-primary mb-2" />
          <CardTitle>Current Roles</CardTitle>
          <CardDescription>
            Leadership positions across various organizations
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-muted-foreground">
            <li>• President, Golden Heart Foundation & National Development Centre</li>
            <li>• Board Member, Institute of National Transformation</li>
            <li>• Member, National Institute for Public Policy & Strategic Studies</li>
            <li>• Alumnus, Lagos Business School & IESE Business School (Spain)</li>
            <li>• Board member of six big organisations with a focus on development & transformation</li>
          </ul>
        </CardContent>
      </Card>

      <Card className="border-border/70 bg-card/90">
        <CardContent className="space-y-4 p-8 text-center">
          <h2 className="text-xl font-bold">Continue Exploring</h2>
          <p className="text-muted-foreground">
            Learn more about the ministry and its impact
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/about">
              <Button variant="outline">About Dr David</Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline">Contact</Button>
            </Link>
            <Link to="/give">
              <Button variant="default">
                Partner With Us
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
